export const environment = {
  production: true,
  APIProtocol: 'https://',
  APIIp: 'staging.keton.io',
  APIPort: '443',
  APIContext: '/rpc',
  typeOfEnv: 'staging',
  brokerHost: 'wss://staging.keton.io:9001',
  clarityProjectId: "wqefht2h9n",
  bypassLogin: false
};
